module.exports = __webpack_public_path__ + "img/cabin.c4ccc9ee.jpg";